<template>
  <v-col 
    cols="12" 
    sm="6" 
    md="4"
    class="mb-4"
  >
    <v-card 
      class="order-card elevation-3"
      :class="`category-${order.category.name.toLowerCase().replace(/\s+/g, '-')}`"
      hover
      @click="showDetail"
    >
      <v-card-text class="pa-3">
        <!-- Header com categoria destacada -->
        <div class="category-header mb-2" :style="{ backgroundColor: order.category.color + '15', borderLeft: '3px solid ' + order.category.color }">
          <div class="d-flex align-center pa-2">
            <v-avatar 
              :color="order.category.color" 
              size="36"
              class="mr-2 elevation-2"
            >
              <v-icon color="white" size="18">{{ order.category.icon }}</v-icon>
            </v-avatar>
            <div class="flex-grow-1">
              <h3 class="text-subtitle-1 font-weight-bold mb-0" :style="{ color: order.category.color }">
                {{ order.category.name }}
              </h3>
              <div class="d-flex align-center">
                <span class="text-caption order-id">#{{ order.id }}</span>
                <span class="text-caption order-code ml-1" v-if="order.code">• {{ order.code }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Poço e Datas em linha -->
        <div class="d-flex mb-2 well-dates-row">
          <!-- Poço destacado -->
          <div class="well-section flex-grow-1 mr-1">
            <div class="well-card pa-2 d-flex align-center" :style="{ backgroundColor: order.category.color + '08', border: '1px solid ' + order.category.color + '30', minHeight: '48px' }">
              <v-icon :color="order.category.color" size="16" class="mr-1">water_drop</v-icon>
              <span class="text-caption well-label">Poço</span>
              <v-spacer></v-spacer>
              <span class="text-body-1 font-weight-bold well-number" :style="{ color: order.category.color }">
                #{{ order.well_id }}
              </span>
            </div>
          </div>

          <!-- Datas compactas -->
          <div class="dates-section flex-grow-1 ml-1">
            <div class="dates-card pa-2 d-flex flex-column justify-center" :style="{ backgroundColor: order.category.color + '08', border: '1px solid ' + order.category.color + '30', minHeight: '48px' }">
              <div class="date-item d-flex align-center justify-space-between mb-1">
                <div class="d-flex align-center">
                  <v-icon :color="order.category.color" size="14" class="mr-1">play_circle_filled</v-icon>
                  <span class="text-caption font-weight-medium">Início</span>
                </div>
                <span class="text-caption font-weight-bold date-value">{{ order.date_start }}</span>
              </div>
              <v-divider class="my-1" :style="{ borderColor: order.category.color + '40' }"></v-divider>
              <div class="date-item d-flex align-center justify-space-between">
                <div class="d-flex align-center">
                  <v-icon :color="order.category.color" size="14" class="mr-1">check_circle</v-icon>
                  <span class="text-caption font-weight-medium">Conclusão</span>
                </div>
                <span class="text-caption font-weight-bold date-value">{{ order.date_end }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Endereço completo -->
        <div class="address-section mb-2" v-if="order.address">
          <div class="d-flex align-start">
            <v-icon color="#9E9E9E" size="14" class="mr-1 mt-1">location_on</v-icon>
            <span class="text-caption address-text">
              {{ order.address.address_full }}
            </span>
          </div>
        </div>

        <!-- Botão de detalhes -->
        <div class="text-center">
          <v-btn 
            :color="order.category.color" 
            outlined 
            small
            class="details-btn"
            @click.stop="showDetail"
          >
            <v-icon left small>visibility</v-icon>
            Ver Detalhes
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "OrderCard",
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  methods: {
    showDetail() {
      this.$emit('show-detail', this.order);
    }
  }
};
</script>

<style scoped>
/* Estilos para os cards de ordens de serviço */
.order-card {
  border-radius: 16px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.order-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15) !important;
  border-color: rgba(0, 0, 0, 0.1);
}

/* Header da categoria */
.category-header {
  border-radius: 8px !important;
  transition: all 0.3s ease;
}

.order-card:hover .category-header {
  transform: scale(1.01);
}

/* Avatar da categoria */
.v-avatar {
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
}

.order-card:hover .v-avatar {
  transform: scale(1.05) rotate(3deg);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25) !important;
}

/* Título da categoria */
.text-subtitle-1 {
  transition: all 0.3s ease;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.order-card:hover .text-subtitle-1 {
  transform: translateX(1px);
}

/* ID e código da ordem */
.order-id {
  color: #666;
  font-weight: 500;
  background: rgba(0, 0, 0, 0.05);
  padding: 1px 6px;
  border-radius: 8px;
  font-size: 0.7rem;
}

.order-code {
  color: #999;
  font-size: 0.7rem;
}

/* Seção do poço */
.well-section {
  transition: all 0.3s ease;
}

.well-card {
  border-radius: 8px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.well-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.order-card:hover .well-card::before {
  transform: translateX(100%);
}

.well-label {
  color: #666;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-size: 0.7rem;
}

.well-number {
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  background: rgba(0, 0, 0, 0.05);
  padding: 2px 8px;
  border-radius: 12px;
  display: inline-block;
  font-size: 0.9rem !important;
}

.order-card:hover .well-number {
  transform: scale(1.05);
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

/* Seção de datas */
.dates-section {
  transition: all 0.3s ease;
}

.dates-card {
  border-radius: 8px !important;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.dates-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.order-card:hover .dates-card::before {
  transform: translateX(100%);
}

.date-item {
  transition: all 0.3s ease;
}

.date-value {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.order-card:hover .date-value {
  transform: translateX(2px);
}

/* Seção de endereço */
.address-section {
  background: rgba(158, 158, 158, 0.05);
  border-radius: 6px;
  padding: 6px;
  border-left: 2px solid #9E9E9E;
}

.address-text {
  color: #666;
  line-height: 1.3;
  font-size: 0.7rem;
}

/* Botão de detalhes */
.details-btn {
  border-radius: 20px !important;
  text-transform: none !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  position: relative;
  overflow: hidden;
}

.details-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.details-btn:hover::before {
  left: 100%;
}

.details-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15) !important;
}

/* Layout responsivo para poço e datas */
.well-dates-row {
  flex-wrap: wrap;
}

@media (max-width: 768px) {
  .well-dates-row {
    flex-direction: column;
  }
  
  .well-section,
  .dates-section {
    margin-left: 0 !important;
    margin-right: 0 !important;
    margin-bottom: 8px;
  }
  
  .dates-section:last-child {
    margin-bottom: 0;
  }
}

/* Responsividade */
@media (max-width: 600px) {
  .order-card {
    margin-bottom: 12px;
  }
  
  .category-header,
  .well-card,
  .dates-card,
  .address-section {
    padding: 8px !important;
  }
  
  .text-subtitle-1 {
    font-size: 0.9rem !important;
  }
  
  .well-number {
    font-size: 0.8rem !important;
  }
  
  .date-value {
    font-size: 0.7rem !important;
  }
  
  .well-card,
  .dates-card {
    min-height: 44px !important;
  }
}

/* Animações de entrada */
.order-card {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Delay escalonado para os cards */
.order-card:nth-child(1) { animation-delay: 0.1s; }
.order-card:nth-child(2) { animation-delay: 0.2s; }
.order-card:nth-child(3) { animation-delay: 0.3s; }
.order-card:nth-child(4) { animation-delay: 0.4s; }
.order-card:nth-child(5) { animation-delay: 0.5s; }
.order-card:nth-child(6) { animation-delay: 0.6s; }
</style>
